// extracted by mini-css-extract-plugin
export var dropZoneViewServiceIcon = "drop-zone-view__service-icon_G3n7kje3tuUHf8pn3VGQ";